import { createAction } from 'redux-actions';

export const APP_TOAST_ADD = 'APP_TOAST_ADD';

export default createAction(APP_TOAST_ADD);
